import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [refCode, setRefCode] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const ref = params.get("ref");
    if (ref) setRefCode(ref.toUpperCase());
  }, [params]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await register(name, email, password, refCode || null);
    setLoading(false);
    if (res.ok) {
      toast.success("Account created — welcome to Novya");
      nav("/dashboard");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div data-testid="register-page" className="min-h-[80vh] flex items-center">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 w-full grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-novya-muted">Apply</div>
          <h1 className="mt-6 font-display font-black text-5xl md:text-6xl tracking-tighter leading-[0.95] text-novya-ink">
            Start your leap.
          </h1>
          <p className="mt-6 text-novya-muted max-w-md leading-relaxed">
            Create an account to pick your track and reserve a seat in the next cohort. No card until you&apos;re ready to enroll.
          </p>
        </div>

        <form onSubmit={submit} className="md:col-span-6 md:col-start-7 border border-novya-border p-8 md:p-12 bg-white">
          <div className="space-y-6">
            <label className="block">
              <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-novya-muted">Full name</span>
              <input
                data-testid="register-name-input"
                type="text" required value={name} onChange={(e) => setName(e.target.value)}
                className="mt-2 w-full border-b border-novya-ink bg-transparent py-3 outline-none focus:border-novya-accent"
              />
            </label>
            <label className="block">
              <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-novya-muted">Email</span>
              <input
                data-testid="register-email-input"
                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-2 w-full border-b border-novya-ink bg-transparent py-3 outline-none focus:border-novya-accent"
              />
            </label>
            <label className="block">
              <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-novya-muted">Password (6+ chars)</span>
              <input
                data-testid="register-password-input"
                type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-2 w-full border-b border-novya-ink bg-transparent py-3 outline-none focus:border-novya-accent"
              />
            </label>
            <label className="block">
              <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-novya-muted">Referral code (optional)</span>
              <input
                data-testid="register-referral-input"
                type="text" value={refCode} onChange={(e) => setRefCode(e.target.value.toUpperCase())}
                placeholder="NOVYA-XXXX"
                className="mt-2 w-full border-b border-novya-border bg-transparent py-3 outline-none focus:border-novya-accent font-mono"
              />
            </label>
          </div>
          <button
            data-testid="register-submit-btn"
            type="submit" disabled={loading}
            className="mt-10 w-full py-4 bg-novya-ink text-white font-medium hover:bg-novya-accent transition-colors disabled:opacity-50"
          >
            {loading ? "Creating…" : "Create account"}
          </button>
          <p className="mt-6 text-sm text-novya-muted">
            Already have one? <Link to="/login" data-testid="register-to-login" className="text-novya-ink font-medium link-underline">Sign in</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
